function haveObjectProperties(obj) {
  if (typeof obj !== 'object') {
    return false;
  }

  return Object.keys(obj).length !== 0;
}

const calculatePercentage = num => parseInt(num * 1000) / 10;

const getPageNameWithoutRegion = pageName =>
  pageName
    .split('_')
    .slice(0, -1)
    .join('_');

const generatePostUrl = ({ urlTitle, id }) => `post/${urlTitle}-${id}`;

module.exports.haveObjectProperties = haveObjectProperties;
module.exports.calculatePercentage = calculatePercentage;
module.exports.generatePostUrl = generatePostUrl;
module.exports.getPageNameWithoutRegion = getPageNameWithoutRegion;



// WEBPACK FOOTER //
// ./app/utils/utility.js